import http from '@/utils/http'

export function getProfile(){
  return  http('/profile')
}

export function putProfile(data){
    return  http.put('/profile',data)
}

export function updateStudying(data){
    return  http.put('/updateStudying',data)
}

export function getStudying(){
    return  http('/getStudying')
}

export function getAnswerToRedisKeyList(){
    return  http('/getAnswerToRedisKeyList')
}

export function updateAvatar(data){
    return  http.put('/updateAvatar',data)
}

export function searchUser(params){
    return  http('/users',{params})
}
